import { useState, useEffect } from 'react';
import { User, onAuthStateChanged, signInWithEmailLink, signOut } from 'firebase/auth';
import { auth } from '../lib/firebase';

export function useAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const signInWithMagicLink = async (email: string, actionCode: string) => {
    try {
      const result = await signInWithEmailLink(auth, email, actionCode);
      return result.user;
    } catch (error) {
      console.error('Error signing in with magic link:', error);
      throw error;
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error signing out:', error);
      throw error;
    }
  };

  return {
    user,
    loading,
    signInWithMagicLink,
    logout,
  };
}
